import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Bell = createSvgIcon(
  <path d="M7.5 4.5c0 .23.017.455.05.675A8.997 8.997 0 0 0 3 13v4.445l-3 3.5V27h24v-6.055l-3-3.5V13a8.997 8.997 0 0 0-4.55-7.825A4.5 4.5 0 1 0 7.5 4.5ZM12 3a1.5 1.5 0 0 1 1.45 1.116 9.065 9.065 0 0 0-2.9 0A1.5 1.5 0 0 1 12 3Zm0 4a6 6 0 0 1 6 6v5.555l3 3.5V24H3v-1.945l3-3.5V13a6 6 0 0 1 6-6Zm0 25a3 3 0 0 0 3-3H9a3 3 0 0 0 3 3Z" />,
  'Bell'
);

export { Bell };
